 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-032ee81d":"90280ab5","chunk-090ec1ef":"9533e824","chunk-0b960ee0":"2824ed9e","chunk-2d2172bd":"cd1b1488","chunk-4cc6bf42":"61adccf3","chunk-e45921be":"3318ba95","chunk-59891b4b":"ce43b806","chunk-644e9296":"ec788198","chunk-693f2867":"db327001","chunk-0f44cad0":"cf21a27d","chunk-00978fa7":"0527eecd","chunk-c6b0b8dc":"555f52fe","chunk-6ef7b238":"0cba0620","chunk-6f678092":"fda6a1b5","chunk-1f49aa56":"6510d3fa","chunk-42c7805f":"a1918510","chunk-518cb1cb":"6f77d681","chunk-54fd49b8":"5bd6ac49","chunk-1f8552cc":"bc823771","chunk-4555a4a2":"221bafc9","chunk-2d22693c":"7716a7e9","chunk-4222e5de":"0c5eec21","chunk-2968eae9":"2447b6de","chunk-485bbb7a":"d02b2893","chunk-802c9b3c":"49c829f6","chunk-b9bc3c82":"988b6ed5","chunk-2d22d3f4":"ab9e231a","chunk-7c020210":"e70705c3","chunk-188adc3a":"d44e4a75","chunk-27dd9a6e":"d5816be2","chunk-df2ead5c":"7fbaa38f","chunk-4eec42df":"e8245858","chunk-2d0aa281":"1472801e","chunk-2d0ae5d6":"a5dfe897","chunk-2d0da355":"55844fb0","chunk-2d216ba8":"0859f836","chunk-3c1e7ab8":"88540902","chunk-b57fc804":"7f6b8cfa","chunk-2a7dbf2d":"2cd3e487","chunk-2d0a3159":"9a7ea1bd","chunk-2d0dd7af":"aa7cde2b","chunk-2d0ddba1":"c666edaf","chunk-2d20864f":"18e35d69","chunk-2d22b970":"1958fa37","chunk-2d21a841":"792ae65a","chunk-2d237ffc":"cbd4b82d","chunk-34600f72":"95c2a848","chunk-3804297c":"9c7963ae","chunk-392fa8a0":"e8a44216","chunk-63a6c5e6":"802281a0","chunk-397283d8":"d44daefe","chunk-413a7242":"fc5b443c","chunk-588a8186":"9ac03f1a","chunk-5e550473":"efe046b5","chunk-5e925fe4":"92d7f8d2","chunk-6cf6e630":"28abe3f0","chunk-7d1c7ffa":"8fcc4809","chunk-bb5199a8":"c05ee387","chunk-bd08044c":"0cceb2b7","chunk-d796411a":"f87fdd78","chunk-b4b9de50":"a8be882d","chunk-f0174638":"afea22d8","chunk-28f7e008":"01edaa02","chunk-2d0cc2ee":"c0083ef2","chunk-3e2e8798":"883ccb4d","chunk-486b84cc":"92b21931","chunk-782db2bb":"f1fe2bbf","chunk-0d85870c":"2761b2a1","chunk-13d1b9be":"9b84d149","chunk-15d5b040":"8c0bcf5c","chunk-2d209b31":"54072f58","chunk-533258a9":"a58e1f15","chunk-6b4e815d":"7b73f616","chunk-7ea86b38":"7668341e","chunk-e4b089ee":"400d7475","chunk-2d2223ef":"8ca0d86b","chunk-3f454ceb":"1d1cb2a5","chunk-60c0f67f":"e46998dd","chunk-6fb4b961":"c058df63","chunk-7025fed6":"b22ef542","chunk-743c2ddb":"a76340f5","chunk-745a3122":"a496ad2d","chunk-7467d5b8":"81acc37a","chunk-747441da":"44e0ff1b","chunk-7482e5bc":"a45e4312","chunk-74af77ea":"72d835d8","chunk-74b7681c":"af3b4519","chunk-74bb0962":"1d1c34d4","chunk-76f042f8":"cf4c94f3","chunk-774c8cf7":"d2e748d9","chunk-78aa6286":"e6e79de5","chunk-368c428a":"fb29bea5","chunk-7457c560":"de003d3e","chunk-274ce549":"047dcfca","chunk-8b8c743c":"cb59903a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-032ee81d":1,"chunk-090ec1ef":1,"chunk-0b960ee0":1,"chunk-4cc6bf42":1,"chunk-e45921be":1,"chunk-59891b4b":1,"chunk-644e9296":1,"chunk-693f2867":1,"chunk-0f44cad0":1,"chunk-c6b0b8dc":1,"chunk-6ef7b238":1,"chunk-6f678092":1,"chunk-1f49aa56":1,"chunk-42c7805f":1,"chunk-518cb1cb":1,"chunk-54fd49b8":1,"chunk-1f8552cc":1,"chunk-4555a4a2":1,"chunk-4222e5de":1,"chunk-2968eae9":1,"chunk-485bbb7a":1,"chunk-802c9b3c":1,"chunk-b9bc3c82":1,"chunk-7c020210":1,"chunk-188adc3a":1,"chunk-27dd9a6e":1,"chunk-4eec42df":1,"chunk-3c1e7ab8":1,"chunk-2a7dbf2d":1,"chunk-34600f72":1,"chunk-3804297c":1,"chunk-392fa8a0":1,"chunk-63a6c5e6":1,"chunk-397283d8":1,"chunk-413a7242":1,"chunk-588a8186":1,"chunk-5e550473":1,"chunk-5e925fe4":1,"chunk-6cf6e630":1,"chunk-7d1c7ffa":1,"chunk-bb5199a8":1,"chunk-bd08044c":1,"chunk-d796411a":1,"chunk-b4b9de50":1,"chunk-f0174638":1,"chunk-28f7e008":1,"chunk-486b84cc":1,"chunk-782db2bb":1,"chunk-0d85870c":1,"chunk-13d1b9be":1,"chunk-15d5b040":1,"chunk-533258a9":1,"chunk-6b4e815d":1,"chunk-7ea86b38":1,"chunk-e4b089ee":1,"chunk-3f454ceb":1,"chunk-60c0f67f":1,"chunk-6fb4b961":1,"chunk-7025fed6":1,"chunk-743c2ddb":1,"chunk-745a3122":1,"chunk-7467d5b8":1,"chunk-747441da":1,"chunk-7482e5bc":1,"chunk-74af77ea":1,"chunk-74b7681c":1,"chunk-74bb0962":1,"chunk-76f042f8":1,"chunk-774c8cf7":1,"chunk-78aa6286":1,"chunk-368c428a":1,"chunk-7457c560":1,"chunk-274ce549":1,"chunk-8b8c743c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-032ee81d":"097b5913","chunk-090ec1ef":"21db3db3","chunk-0b960ee0":"f7fa28aa","chunk-2d2172bd":"31d6cfe0","chunk-4cc6bf42":"95dd64be","chunk-e45921be":"73088838","chunk-59891b4b":"25e1cee2","chunk-644e9296":"7de0dee6","chunk-693f2867":"0f4fa8af","chunk-0f44cad0":"085a4e18","chunk-00978fa7":"31d6cfe0","chunk-c6b0b8dc":"e0f54368","chunk-6ef7b238":"4a1acabc","chunk-6f678092":"df61947d","chunk-1f49aa56":"2523ca53","chunk-42c7805f":"7754441b","chunk-518cb1cb":"69c23168","chunk-54fd49b8":"6f8314ce","chunk-1f8552cc":"5b7563f1","chunk-4555a4a2":"b7cdec93","chunk-2d22693c":"31d6cfe0","chunk-4222e5de":"7e1ecbad","chunk-2968eae9":"832f84b9","chunk-485bbb7a":"3cb9bc2d","chunk-802c9b3c":"9d26a2d6","chunk-b9bc3c82":"16b92b30","chunk-2d22d3f4":"31d6cfe0","chunk-7c020210":"e17cb967","chunk-188adc3a":"2c6fc431","chunk-27dd9a6e":"37df1425","chunk-df2ead5c":"31d6cfe0","chunk-4eec42df":"440937b0","chunk-2d0aa281":"31d6cfe0","chunk-2d0ae5d6":"31d6cfe0","chunk-2d0da355":"31d6cfe0","chunk-2d216ba8":"31d6cfe0","chunk-3c1e7ab8":"902d1a8d","chunk-b57fc804":"31d6cfe0","chunk-2a7dbf2d":"effb2c29","chunk-2d0a3159":"31d6cfe0","chunk-2d0dd7af":"31d6cfe0","chunk-2d0ddba1":"31d6cfe0","chunk-2d20864f":"31d6cfe0","chunk-2d22b970":"31d6cfe0","chunk-2d21a841":"31d6cfe0","chunk-2d237ffc":"31d6cfe0","chunk-34600f72":"b5d11d1b","chunk-3804297c":"9f69edb5","chunk-392fa8a0":"c40cfcff","chunk-63a6c5e6":"1d121968","chunk-397283d8":"6778cc5a","chunk-413a7242":"cf11257f","chunk-588a8186":"6e709d2d","chunk-5e550473":"6e709d2d","chunk-5e925fe4":"5cc6dd92","chunk-6cf6e630":"ddb6d2a6","chunk-7d1c7ffa":"99672fc4","chunk-bb5199a8":"3e025a0f","chunk-bd08044c":"ef0da253","chunk-d796411a":"e13d7cb7","chunk-b4b9de50":"6743af7d","chunk-f0174638":"89b0ff92","chunk-28f7e008":"a333bbd6","chunk-2d0cc2ee":"31d6cfe0","chunk-3e2e8798":"31d6cfe0","chunk-486b84cc":"8e1887f0","chunk-782db2bb":"35c07f6a","chunk-0d85870c":"2405960a","chunk-13d1b9be":"bedc82b4","chunk-15d5b040":"07cc3c21","chunk-2d209b31":"31d6cfe0","chunk-533258a9":"b96a9913","chunk-6b4e815d":"24800e73","chunk-7ea86b38":"50eea547","chunk-e4b089ee":"415e0290","chunk-2d2223ef":"31d6cfe0","chunk-3f454ceb":"1177320e","chunk-60c0f67f":"d6e63a1f","chunk-6fb4b961":"eb89e009","chunk-7025fed6":"62d5df80","chunk-743c2ddb":"0dd2478f","chunk-745a3122":"d7dc1639","chunk-7467d5b8":"97906909","chunk-747441da":"e22b5965","chunk-7482e5bc":"3fc962f4","chunk-74af77ea":"23b17eb2","chunk-74b7681c":"6ff76692","chunk-74bb0962":"06c127ee","chunk-76f042f8":"a3d504dc","chunk-774c8cf7":"93e9293c","chunk-78aa6286":"18f5736b","chunk-368c428a":"f5ac69c0","chunk-7457c560":"d4ad834b","chunk-274ce549":"9bf5d907","chunk-8b8c743c":"7a7eb628"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://presenter.ahaslides.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
